import { activityStateEnum, crudStatus, formTemplateStatusEnum, gnrState, materialState, reportStateEnum, reportTypeEnum } from './enums';

export const customColors = {
    red: 'crimson',
    green: 'lightgreen',
    gray: 'lightgray',
    yellow: 'yellow',
    blue: 'blue',
    orange: 'orange',
    lightblue: 'lightblue',
    purple: 'purple',
    pink: 'pink',
    cyan: 'cyan',
    brown: 'brown',
};

const pastelGreen = '#778D45';

export const getMaterialStateColor = (state: number | undefined) => {
    switch (state) {
        case materialState.NEW:
            return 'lightgreen';
        case materialState.PRESENT:
            return 'lightgray';
        case materialState.REMOVE:
            return 'rgb(255,200,100) ';
        default:
            return '';
    }
};
export const getTextColor = (bgColor: string) => {
    const rgb = parseInt(bgColor.slice(1), 16);
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = (rgb >> 0) & 0xff;

    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

    return luminance > 128 ? 'black' : 'white';
};

export const getStatusColor = (status: number | undefined) => {
    switch (status) {
        case crudStatus.OK:
            return 'rgb(105, 144, 115)';
        case crudStatus.INACTIVE:
            return customColors.gray;
        case crudStatus.DELETED:
            return customColors.red;
        default:
            return customColors.yellow;
    }
};

export const getReportStateColor = (state: number | undefined) => {
    switch (state) {
        case reportStateEnum.NEEDS:
            return '#E0E0E0';
        case reportStateEnum.PLANNING:
            return '#A3D9FF';
        case reportStateEnum.REPORT:
            return '#FFC000';
        case reportStateEnum.REPORTFILLED:
            return '#88D8A8';
        case reportStateEnum.VALIDATED:
            return '#00B050';
        default:
            return '#E0E0E0';
    }
};

export const getReportTypeColor = (state: number | undefined) => {
    switch (state) {
        case reportTypeEnum.ABSENT:
            return 'crimson';
        case reportTypeEnum.SITE:
            return '#79d2e6';
        default:
            return '';
    }
};

export const getActivityStateColor = (state: number | undefined) => {
    switch (state) {
        case activityStateEnum.ENTERED:
            return 'purple';
        case activityStateEnum.VALIDATED:
            return 'green';
        case activityStateEnum.SEMIVALIDATED:
            return 'blue';
        case activityStateEnum.VALIDATION:
            return 'orange';
        case activityStateEnum.REPORTFILLED:
            return pastelGreen;
        case activityStateEnum.REPORT:
            return 'yellow';
        case activityStateEnum.PLANNINGSENT:
            return pastelGreen;
        case activityStateEnum.PLANNING:
            return 'yellow';
        case activityStateEnum.NEEDSIMPORTED:
            return '#CB22C1';
        case activityStateEnum.NEEDSSENT:
            return pastelGreen;
        case activityStateEnum.NEEDSFILLED:
            return 'orange';
        case activityStateEnum.NEEDS:
            return 'yellow';
        default:
            return 'yellow';
    }
};

export const getGnrStateColor = (state: number | undefined) => {
    switch (state) {
        case gnrState.REQUESTED:
            return 'lightblue';
        case gnrState.IN_PROGRESS:
            return 'gold';
        case gnrState.DELIVERED:
            return pastelGreen;
        case gnrState.CANCELED:
            return 'gray';
        case gnrState.ARCHIVED:
            return '#616161';
        default:
            return '';
    }
};

export const getColorByPercentage = (value: number, max: number): string => {
    const percentage = (value / max) * 100;

    if (percentage <= 20) return 'crimson';
    if (percentage <= 40) return 'darkorange';
    if (percentage <= 60) return 'orange';
    if (percentage <= 80) return '#9ACD32';
    return 'limegreen';
};

export const getFormTemplateStatusColor = (type: number | undefined) => {
    switch (type) {
        case formTemplateStatusEnum.DRAFT:
            return 'yellow';
        case formTemplateStatusEnum.PUBLISHED:
            return 'green';
        case formTemplateStatusEnum.INACTIVE:
            return 'gray';
        default:
            return '';
    }
};
